// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U9b0ocnq_pJCmsOp7F_f {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.OiD5CfdHT3MtlpzaErVU {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 20px;
  min-height: 148px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #1f1f1f;
  font-size: 14px;
}

.TuAHiiBdJvHcZe0_rZdj {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1 0 260px;
  min-width: min(100%, 260px);
  max-width: 100%;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  background: #fff;
  gap: 16px;
  overflow: hidden;
  transition:
    box-shadow 200ms,
    border-color 200ms;
}

.TuAHiiBdJvHcZe0_rZdj:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-color: #d0d0d0;
}

.Sf9WxAgHIV0NUsDsCZsA {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 26px;
  min-width: 0;
}

.D3VBapbML5nFBLmu0eEi {
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  color: var(--sl-fg-base-soft, #707070);
  letter-spacing: -0.32px;
  line-height: 24px;
}

.RonJ_ymB5BZK7U_Iruuz {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 8px;
  flex-shrink: 0;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #1f1f1f;
}

.VcDKhVQKS604KudsAyvA,
.ZB0S8L07YbOzWN_eeV3v {
  flex-shrink: 0;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.VcDKhVQKS604KudsAyvA {
  border-bottom: 5px solid currentColor;
}

.ZB0S8L07YbOzWN_eeV3v {
  border-top: 5px solid currentColor;
}

.R1xoXTAqjdHmJGcoA0zE {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.QPRyBMZwIsmVd37W7jCy {
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}

.w1SBYsNKQOrF6VZDjHBn {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  min-height: 42px;
  min-width: 0;
}

.n1uIs0kKKg4kUhiO_MEj {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  color: var(--sl-fg-base, #1f1f1f);
  letter-spacing: -1.12px;
  font-variant-numeric: tabular-nums;
  line-height: normal;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.U317SjikwhfofYEtPkXw {
  font-size: 16px;
  font-weight: 400;
  color: var(--sl-fg-base-soft, #707070);
  letter-spacing: -0.32px;
  line-height: 24px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
  white-space: nowrap;
}

.APvE4W6ZjDMiA4p2cR6b {
  width: 100%;
  height: 6px;
  background: #eaeaea;
  border-radius: 2px;
  overflow: hidden;
}

.gHoixM4cfORg4wzcIgc7 {
  height: 100%;
  border-radius: 2px;
  transform-origin: left;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/pages/campaigns/spend-reports/elements/PacingCard/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB;;sBAEoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB","sourcesContent":[".grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 16px;\n  width: 100%;\n  min-width: 0;\n}\n\n.errorCard {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  width: 100%;\n  padding: 20px;\n  min-height: 148px;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  color: #1f1f1f;\n  font-size: 14px;\n}\n\n.card {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 260px;\n  min-width: min(100%, 260px);\n  max-width: 100%;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  gap: 16px;\n  overflow: hidden;\n  transition:\n    box-shadow 200ms,\n    border-color 200ms;\n}\n\n.card:hover {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border-color: #d0d0d0;\n}\n\n.header {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 26px;\n  min-width: 0;\n}\n\n.title {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--sl-fg-base-soft, #707070);\n  letter-spacing: -0.32px;\n  line-height: 24px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n  color: #1f1f1f;\n}\n\n.badgeArrowUp,\n.badgeArrowDown {\n  flex-shrink: 0;\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n}\n\n.badgeArrowUp {\n  border-bottom: 5px solid currentColor;\n}\n\n.badgeArrowDown {\n  border-top: 5px solid currentColor;\n}\n\n.badgeDot {\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: currentColor;\n}\n\n.body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  flex-direction: column;\n  justify-content: space-between;\n  min-width: 0;\n}\n\n.valueRow {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 42px;\n  min-width: 0;\n}\n\n.value {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 500;\n  color: var(--sl-fg-base, #1f1f1f);\n  letter-spacing: -1.12px;\n  font-variant-numeric: tabular-nums;\n  line-height: normal;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.percentage {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--sl-fg-base-soft, #707070);\n  letter-spacing: -0.32px;\n  line-height: 24px;\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.progressTrack {\n  width: 100%;\n  height: 6px;\n  background: #eaeaea;\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  border-radius: 2px;\n  transform-origin: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `U9b0ocnq_pJCmsOp7F_f`,
	"errorCard": `OiD5CfdHT3MtlpzaErVU`,
	"card": `TuAHiiBdJvHcZe0_rZdj`,
	"header": `Sf9WxAgHIV0NUsDsCZsA`,
	"title": `D3VBapbML5nFBLmu0eEi`,
	"badge": `RonJ_ymB5BZK7U_Iruuz`,
	"badgeArrowUp": `VcDKhVQKS604KudsAyvA`,
	"badgeArrowDown": `ZB0S8L07YbOzWN_eeV3v`,
	"badgeDot": `R1xoXTAqjdHmJGcoA0zE`,
	"body": `QPRyBMZwIsmVd37W7jCy`,
	"valueRow": `w1SBYsNKQOrF6VZDjHBn`,
	"value": `n1uIs0kKKg4kUhiO_MEj`,
	"percentage": `U317SjikwhfofYEtPkXw`,
	"progressTrack": `APvE4W6ZjDMiA4p2cR6b`,
	"progressFill": `gHoixM4cfORg4wzcIgc7`
};
export default ___CSS_LOADER_EXPORT___;
